var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMemory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 22C13.866 22 17 18.866 17 15C17 11.134 13.866 8 10 8C6.13401 8 3 11.134 3 15C3 18.866 6.13401 22 10 22Z",
    fill: "#E5BEB0",
    stroke: "#3F2C26",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2 2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 15C25.866 15 29 11.866 29 8C29 4.13401 25.866 1 22 1C18.134 1 15 4.13401 15 8C15 11.866 18.134 15 22 15Z",
    fill: "#AFBBE1",
    stroke: "#3F2C26",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2 2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34 36C37.866 36 41 32.866 41 29C41 25.134 37.866 22 34 22C30.134 22 27 25.134 27 29C27 32.866 30.134 36 34 36Z",
    fill: "#D9D9D9",
    stroke: "#3F2C26",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2 2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 36C13.866 36 17 32.866 17 29C17 25.134 13.866 22 10 22C6.13401 22 3 25.134 3 29C3 32.866 6.13401 36 10 36Z",
    fill: "#F1BEED",
    stroke: "#3F2C26",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2 2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22 43C25.866 43 29 39.866 29 36C29 32.134 25.866 29 22 29C18.134 29 15 32.134 15 36C15 39.866 18.134 43 22 43Z",
    fill: "#F1786C",
    stroke: "#3F2C26",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2 2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34 22C37.866 22 41 18.866 41 15C41 11.134 37.866 8 34 8C30.134 8 27 11.134 27 15C27 18.866 30.134 22 34 22Z",
    fill: "#448B7E",
    stroke: "#3F2C26",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemory);
export default __webpack_public_path__ + "static/media/Memory.224f8373a1d381c6391a65a596ab2710.svg";
export { ForwardRef as ReactComponent };